import React, { useState } from "react";
import PropTypes from "prop-types";
import { Icon, InlineStack, Text } from "@shopify/polaris";
import { AlertTriangleIcon, XIcon } from "@shopify/polaris-icons";

const UrgentTasksBanner = ({ taskCount = 5 }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="operator-dashboard-urgent-banner">
      <InlineStack align="space-between" blockAlign="center">
        <InlineStack gap="200" blockAlign="center">
          <Icon source={AlertTriangleIcon} tone="warning" />
          <button type="button" className="operator-dashboard-urgent-link">
            <Text as="span" variant="bodyMd" fontWeight="medium">
              Review {taskCount} urgent tasks
            </Text>
          </button>
        </InlineStack>
        <button
          type="button"
          className="operator-dashboard-urgent-dismiss"
          onClick={() => setIsVisible(false)}
          aria-label="Dismiss"
        >
          <Icon source={XIcon} />
        </button>
      </InlineStack>
    </div>
  );
};

UrgentTasksBanner.propTypes = {
  taskCount: PropTypes.number,
};

export default UrgentTasksBanner;
